export default __webpack_public_path__ + "static/media/logo-TM.0e3e6a7e.svg";